import { jsx as _jsx } from "react/jsx-runtime";
import { gql, useApolloClient, useReactiveVar, useFragment } from "@apollo/client";
import { ExperienceScreenUpdatePreferenceFragmentDoc } from "../types";
import { useUpdateBusinessCache } from "../cache/ExperienceScreenUpdatePreferenceFunctions";
import { currentBusinessIdVar } from "../helpers/client";
gql `
fragment ExperienceScreenUpdatePreference on Business {
  enablePastCustomerUpsell
  enableEmailUpsell
  enableRedirectUpsell
  enableSmsUpsell
  enableTips
  enableFAQ
  enableBadge
  enableNavigationLink
  enableAddToCartUpsell
  enableSidebarUpsell
  theme {
    id
    ...UpdateTheme
  }
}
`;
const ExperienceScreenUpdatePreference = ({ option, required = false }) => {
    const currentBusinessId = useReactiveVar(currentBusinessIdVar);
    const client = useApolloClient();
    let updatePreference = (e) => { };
    if (option !== "enableDashboard" && option !== "enableAccountPageLink") {
        updatePreference = useUpdateBusinessCache(currentBusinessId, option);
    }
    if (!currentBusinessId)
        return null;
    const { data: business } = useFragment({
        fragment: ExperienceScreenUpdatePreferenceFragmentDoc,
        fragmentName: "ExperienceScreenUpdatePreference",
        from: {
            __typename: "Business",
            id: currentBusinessId,
        },
    });
    if (!business)
        return null;
    return (_jsx("input", { className: "mr-4 min-w-12 inline self-start cursor-pointer", style: { zoom: 1.3, transform: "translateY(2px)" }, type: "checkbox", name: option, id: option, value: "1", checked: required ? true : business[option], disabled: required, onChange: updatePreference }));
};
export default ExperienceScreenUpdatePreference;
